import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FaQuestionCircle, 
  FaChevronDown, 
  FaChevronUp,
  FaGraduationCap,
  FaSearch,
  FaUsers,
  FaCreditCard,
  FaHeadset,
  FaCertificate,
  FaLaptop,
  FaRocket
} from 'react-icons/fa';
import './PerguntasFrequentes.css';
import { normalizeText } from '../utils/text';

function PerguntasFrequentes() {
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  const faqData = [
    {
      category: "Sobre a Plataforma",
      icon: <FaLaptop />,
      questions: [
        {
          question: "O que é a EAD Conect?",
          answer: "A EAD Conect é uma plataforma de ensino criada por ex-alunos da Univesp e professores com larga experiência em suas áreas com o intuito de dar suporte aos alunos, através de resolução em vídeo de exercícios de Atividade Avaliativa, Provas Resolvidas, Resumos e muito mais. É uma rede social dedicada aos alunos da Univesp. Aqui você pode interagir com seus colegas de todos os polos, compartilhar materiais em PDF, link de vídeos do YouTube, Vimeo e outros."
        },
        {
          question: "A EAD Conect é oficial da Univesp?",
          answer: "Não, a EAD Conect é uma iniciativa independente criada por ex-alunos da Univesp e professores com larga experiência no ensino a distância para complementar e facilitar os estudos dos alunos. Não somos vinculados oficialmente à Univesp."
        },
        {
          question: "Que tipo de conteúdo posso encontrar?",
          answer: "Você encontra materiais organizados por disciplinas, vídeoaulas, exercícios práticos, correção de provas, resumos, e apoio direto de professores especializados."
        }
      ]
    },
    {
      category: "Planos e Pagamento",
      icon: <FaCreditCard />,
      questions: [
        {
          question: "Quais planos estão disponíveis?",
          answer: "Oferecemos planos Anual, Trimestral e Mensal. Todos começam com 3 dias grátis para você testar a plataforma. Os valores variam conforme o período escolhido."
        },
        {
          question: "Como funciona o período gratuito?",
          answer: "Todos os planos incluem 3 dias grátis para você conhecer nossa plataforma. Durante este período, você tem acesso completo a todos os recursos. Você pode cancelar quando quiser."
        },
        {
          question: "Posso cancelar minha assinatura?",
          answer: "Sim! Você pode cancelar sua assinatura a qualquer momento. O cancelamento é simples e pode ser feito diretamente na sua área do usuário."
        },
        {
          question: "Quais formas de pagamento vocês aceitam?",
          answer: "O pagamento é efetuado por cartão de crédito, e é processado de forma segura através de nossa plataforma parceira."
        }
      ]
    },
    {
      category: "Acesso e Suporte",
      icon: <FaHeadset />,
      questions: [
        {
          question: "Como posso tirar dúvidas com os professores?",
          answer: "Você pode enviar suas dúvidas através da plataforma, participar de sessões ao vivo ou agendar atendimentos individuais com nossos professores especializados."
        },
        {
          question: "Posso acessar de qualquer dispositivo?",
          answer: "Sim! Nossa plataforma é responsiva e funciona perfeitamente em computadores, tablets e celulares. Você pode estudar onde e quando quiser."
        },
        {
          question: "E se eu tiver problemas técnicos?",
          answer: "Temos uma equipe de suporte técnico pronta para ajudar. Entre em contato através do chat da plataforma ou envie um e-mail para nosso suporte."
        }
      ]
    },
    {
      category: "Certificação e Provas",
      icon: <FaCertificate />,
      questions: [
        {
          question: "Vocês oferecem certificados?",
          answer: "Não! Somos uma plataforma de estudos e não de formação."
        },
        {
          question: "Como funciona a correção de provas?",
          answer: "Nossos professores fazem correção detalhada das suas provas, apontando erros, acertos e dando dicas de melhoria. Você recebe feedback personalizado para evoluir."
        },
        {
          question: "Os materiais são atualizados?",
          answer: "Sim! Nosso conteúdo é constantemente atualizado pelos professores para refletir as mudanças nos currículos e incluir novos materiais relevantes."
        }
      ]
    }
  ];

  const toggleAccordion = (categoryIndex, questionIndex) => {
    const index = `${categoryIndex}-${questionIndex}`;
    setActiveIndex(activeIndex === index ? null : index);
  };

  const normalizedSearch = normalizeText(searchTerm);
  const filteredFAQ = faqData.map(category => ({
    ...category,
    questions: category.questions.filter(
      q => 
        normalizeText(q.question).includes(normalizedSearch) ||
        normalizeText(q.answer).includes(normalizedSearch)
    )
  })).filter(category => category.questions.length > 0);

  return (
    <div className="perguntas-frequentes-page">
      {/* Hero Section */}
      <section className="faq-hero">
        <div className="faq-hero-content">
          <div className="hero-icon">
            <FaQuestionCircle />
          </div>
          <h1>Perguntas Frequentes</h1>
          <p>Encontre respostas rápidas para suas principais dúvidas sobre a EAD Conect</p>
          
          {/* Barra de Busca */}
          <div className="faq-search">
            <div className="search-container">
              <FaSearch className="search-icon" />
              <input
                type="text"
                placeholder="Busque por uma pergunta ou palavra-chave..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Content */}
      <section className="faq-content">
        <div className="faq-container">
          {filteredFAQ.length > 0 ? (
            filteredFAQ.map((category, categoryIndex) => (
              <div key={categoryIndex} className="faq-category">
                <div className="category-header">
                  <div className="category-icon">{category.icon}</div>
                  <h2>{category.category}</h2>
                </div>
                
                <div className="questions-list">
                  {category.questions.map((item, questionIndex) => {
                    const index = `${categoryIndex}-${questionIndex}`;
                    const isActive = activeIndex === index;
                    
                    return (
                      <div key={questionIndex} className={`faq-item ${isActive ? 'active' : ''}`}>
                        <button
                          className="faq-question"
                          onClick={() => toggleAccordion(categoryIndex, questionIndex)}
                        >
                          <span className="question-text">{item.question}</span>
                          <span className="accordion-icon">
                            {isActive ? <FaChevronUp /> : <FaChevronDown />}
                          </span>
                        </button>
                        
                        <div className={`faq-answer ${isActive ? 'expanded' : ''}`}>
                          <div className="answer-content">
                            <p>{item.answer}</p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ))
          ) : (
            <div className="no-results">
              <FaSearch className="no-results-icon" />
              <h3>Nenhuma pergunta encontrada</h3>
              <p>Tente buscar com outras palavras-chave ou navegue pelas categorias.</p>
              <button onClick={() => setSearchTerm('')} className="clear-search">
                Limpar busca
              </button>
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="faq-cta">
        <div className="cta-container">
          <h2>Não encontrou sua resposta?</h2>
          <p>Nossa equipe está pronta para ajudar você com qualquer dúvida</p>
          
          <div className="cta-buttons">
            <button className="btn-primary" onClick={() => navigate('/cadastro')}>
              <FaGraduationCap /> Comece Gratuitamente
            </button>
            <button className="btn-secondary" onClick={() => navigate('/premium')}>
              <FaRocket /> Ver Planos
            </button>
          </div>
          
          <div className="contact-info">
            <p>
              <FaUsers className="contact-icon" />
              Entre em contato conosco através da plataforma após o cadastro
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default PerguntasFrequentes;
